import { IConfig } from '@/interface/game';
import React, { useState } from 'react';
import QuestGameSceneInit from './RiseBurstGameSceneInit';
import QuestGameBody from './RiseBurstGameBody';
import { renderARElements } from '@/helper/ar';
import QuestGameInst from './RiseBurstGameIns';
import { useAframeSceneLoad } from '@/hooks/useAframeSceneLoad';
import Game from '@/helper/games/riseBurst/Game';

const scripts = [
  {
    uri: 'https://s3.ap-south-1.amazonaws.com/vizaro.in/app/lib/aframe.min.js',
  },

  {
    uri: 'https://s3.ap-south-1.amazonaws.com/vizaro.in/app/lib/aframe-physics-system.min.js',
  },
  {
    uri: 'https://cdn.jsdelivr.net/gh/c-frame/aframe-extras@7.4.0/dist/aframe-extras.min.js',
  },
];

const defaultAssets = [
  {
    type: 'OBJECT',
    uri: 'https://s3.ap-south-1.amazonaws.com/vizaro.in/dump/ar-1.png',
  },
  {
    type: 'OBJECT',
    uri: 'https://s3.ap-south-1.amazonaws.com/vizaro.in/dump/ar-2.png',
  },
];
type RiseBurstGameContentProps = {
  config?: IConfig;
};

const RiseBurstGameContent = ({ config }: RiseBurstGameContentProps) => {
  const [isInst, setIsInst] = useState(false);

  const renderElements = () => {
    let elements = config?.elements || [];

    elements = elements.filter(ele => ele.type !== 'OBJECT');
    renderARElements(elements, undefined, 'Quest');
  };
  const onGameInit = () => {
    const assets = config?.elements || defaultAssets;
    const collectibleAssets = assets.filter(ele => ele.type == 'OBJECT') || [];
    const game = new Game(collectibleAssets, config?.timer || 60);
    game.gameStart();
  };
  const onSceneLoad = () => {
    setIsInst(true);
    setTimeout(() => {
      renderElements();
      setIsInst(false);
      onGameInit();
    }, 4000);
  };
  const { isLoaded } = useAframeSceneLoad({ scripts, onSceneLoad });
  if (!isLoaded) return <div>Loading AR experience...</div>;
  return (
    <div className="" id="markerless">
      {isInst && <QuestGameInst />}
      <QuestGameBody />
      <QuestGameSceneInit />
    </div>
  );
};

export default RiseBurstGameContent;
